import { useContext } from "react";
import { useConfig } from "../../../contexts/ConfigContext";
import { makeStyles } from "@mui/styles";
import { useChatWindowSettings } from "../../../contexts/ChatWindowContext";
import { SocketContext } from "../../../contexts/SocketContext";
import {
  Box,
  Typography,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Fade,
  IconButton,
  Select,
  MenuItem,
} from "@mui/material";
import styles from "../styles";
import { Settings, Close } from "@mui/icons-material";

import {
  DESKTOP_BORDER_RADIUS,
  MOBILE_BORDER_RADIUS,
} from "../../../constants";

const useStyles = makeStyles(styles);

function ChatConfig() {
  const {
    config,
    setConfig,
    configOpen,
    handleToggleConfigModal,
    setConfigInitialized,
    configInitialized,
  } = useConfig();
  const { getWelcomeMessage, resetSession } = useContext(SocketContext);
  const classes = useStyles();
  const { isMobile } = useChatWindowSettings();

  const handleConfigChange = (val, key) => {
    const newConfig = { ...config };
    newConfig.metadataOptions[key] = {
      ...newConfig.metadataOptions[key],
      value: val,
    };
    // set config to localstorage
    localStorage.setItem(
      "webchat_meta",
      JSON.stringify(newConfig.metadataOptions)
    );
    setConfig(newConfig);
  };

  const handleStartChatClick = async () => {
    await new Promise((resolve) => {
      const newConfig = { ...config };
      setConfig(newConfig);
      resolve();
    });
    if (configInitialized) {
      resetSession();
    } else {
      setConfigInitialized(true);
      getWelcomeMessage();
    }
    handleToggleConfigModal();
  };

  return (
    <Box>
      <IconButton sx={{ ml: 1 }} onClick={handleToggleConfigModal} size="small">
        <Settings color="disabled" fontSize="small" />
      </IconButton>
      <Fade timeout={350} unmountOnExit in={configOpen}>
        <Box
          className={classes.chatConfigContainer}
          sx={{
            borderRadius: isMobile
              ? MOBILE_BORDER_RADIUS
              : DESKTOP_BORDER_RADIUS,
          }}
        >
          {configInitialized && (
            <IconButton
              onClick={handleToggleConfigModal}
              sx={{ position: "absolute", top: 9, right: 9 }}
            >
              <Close color="disabled" />
            </IconButton>
          )}
          <Typography variant="subtitle1" sx={{ my: 2 }}>
            Configure your chat
          </Typography>
          {Object.keys(config.metadataOptions).map((key) => (
            <Box key={key} className={classes.chatConfigItem}>
              <Typography color="text.secondary" variant="body2" sx={{ mb: 2 }}>
                {config.metadataOptions[key].label}
              </Typography>
              {config.metadataOptions[key].renderType === "toggleGroup" ? (
                <ToggleButtonGroup
                  exclusive
                  fullWidth
                  color="primary"
                  value={
                    config.metadataOptions[key]?.value ??
                    config.metadataOptions[key].defaultOption
                  }
                  onChange={(e, val) => handleConfigChange(val, key)}
                >
                  {config.metadataOptions[key].options.map((item) => (
                    <ToggleButton key={item.value} value={item.value}>
                      {item.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              ) : config.metadataOptions[key].renderType === "dropdown" ? (
                <Select
                  size="small"
                  fullWidth
                  onChange={(e, val) => handleConfigChange(e.target.value, key)}
                  value={
                    config.metadataOptions[key]?.value ??
                    config.metadataOptions[key].defaultOption
                  }
                >
                  {config.metadataOptions[key].options.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              ) : null}
            </Box>
          ))}

          <Button
            onClick={handleStartChatClick}
            sx={{ mt: 4 }}
            size="large"
            variant="contained"
          >
            Start Chat
          </Button>
        </Box>
      </Fade>
    </Box>
  );
}

export default ChatConfig;
